import React, { useState, useEffect } from 'react';
import { Link, } from "react-router-dom";
import { useScrollHeader } from '../../../hooks';
import './arta.less';
import Footer from "../../../components/Footer/Footer";

function Arta({ setHeaderDark }) {
  useScrollHeader(setHeaderDark, 50); // 50px 触发
  const treatmentList = [
    {
      title: '机制创新',
      desc: '从弱视的神经损伤机制出发，定向训练弱视眼缺损的小细胞通路感知能力，降低眼间抑制。',
      icon: './images/arta/arta1_icon_black.png',
    },
    {
      title: '临床革命',
      // desc: '全球首个全年龄段弱视治疗方案，12岁以下弱视治疗有效率超90%，成人弱视治疗有效率达77.3%。',
      desc: '破解了眼科弱视训练治疗领域长期存在的年龄壁垒局限、难治性弱视两大临床痛点。',
      icon: './images/arta/arta2_icon_black.png',
    },
    {
      title: '增强现实',
      desc: '基于AR技术，将患者日常看到的画面转化为治疗图像，治疗与生活深度融合,极大提升治疗依从性。',
      icon: './images/arta/arta3_icon_black.png',
    },
  ]

  const [hovered, setHovered] = useState(false)

  useEffect(() => {
    window.scrollTo(0, 0); // 进入页面时滚动到顶部
  }, []);

  return (
    <div className="Arta">
      <div className='Arta_cover'>
        <div className='flex_col flex_jc-sb gap_60' style={{ minHeight: '100vh' }}>
          <div className='Arta_cover-titleBolck pageMargin flex_auto'>
            <div className="Arta_cover-title">
              <span>ARTA埃尔塔® </span>
              {/* <span>全年龄弱视治疗仪</span> */}
              <span>视觉功能训练治疗软件</span>
            </div>
            {/* <div className="Arta_cover-subTitle linear-gradient">全球首个全年龄段弱视治疗方案</div> */}
          </div>
          <div className='flex_full flex_row flex_ai-c' style={{ position: 'relative' }}>
            <div className="pageMargin Arta_cover-enDesc linear-gradient">AUGMENTED REALITY TREATMENT FOR AMBLYOPIA</div>
            {/* PC端 */}
            <div className="Arta_imgPc flex_row flex_jc-c">
              <img
                src='./images/arta/arta-banner.png'
                alt=''
              />
            </div>
            {/* 移动端 */}
            <div className="Arta_imgMobile flex_row flex_jc-c">
              <img
                src='./images/arta/arta-img-390.png'
                alt=''
              />
            </div>
          </div>
          <div className='flex_row flex_jc-c flex_auto'>
            <div className="Arta_logo">
              <img
                style={{ width: '100%' }}
                src='./images/arta/arta-logo.svg'
                alt=''
              />
            </div>
          </div>
        </div>
      </div>
      <div className='Arta_content'>
        <div className='Arta_content-top'>
          <div className='Arta_content-topLeft'>
            <div className="Arta_treatmentLogo pt_20">
              <img
                src='./images/arta/arta-logo.svg'
                alt=''
              />
            </div>
            {/* <div className="Arta_content-topTitle linear-gradient">基于全新脑视觉机制的弱视治疗方案</div> */}
            <div className="Arta_content-topTitle linear-gradient">自主研发的基于脑视觉机制的弱视干预方案</div>
          </div>
          <div className="Arta_content-topImg">
            <img
              src='./images/arta/arta-img-3.png'
              alt=''
            />
          </div>
        </div>
        <div className='pageMargin'>
          <div className="Arta_treatmentBlock">
            {treatmentList.map((item, index) => <div key={index} className='Arta_treatment-item'>
              <div className="Arta_treatment-itemContent">
                <img
                  src={item.icon}
                  alt=''
                />
                <div className="Arta_treatment-itemTitle">{item.title}</div>
                <div className="Arta_treatment-itemDesc">{item.desc}</div>
              </div>
            </div>)}
          </div>
          {/* PC端 */}
          <div className="Arta_mechanismPc">
            <div className="Arta_mechanism-img">
              <img
                style={{ width: '100%' }}
                src='./images/arta/cell(222).png'
                alt=''
              />
            </div>
            <div className="Arta_mechanism-right">
              <div className="fz_48 fw_700 lh_56 linear-gradient" style={{ maxWidth: '384px' }}>集视®牵手中科院 揭示弱视病理机制</div>
              <div className="fz_16 fw_500 lh_24 c_85899E mt_56 pb_40" style={{ maxWidth: '497px' }}>
                传统观念认为弱视主要影响人类早期视觉皮层；<br />
                集视团队最新的研究揭示成人弱视外膝体-V1小细胞通路和皮层-上丘通路的功能异常；<br />
                针对弱视神经损伤位点的训练有望解决传统疗法年龄限制、依从性差、效果不佳、回退率高等问题。
              </div>
            </div>
          </div>
          {/* 移动端 */}
          <div className='Arta_mechanismMobile mt_40 flex_col flex_ai-c gap_40'>
            <div className="fz_24 fw_700 lh_28 ta_c linear-gradient">集视®牵手中科院<br />揭示弱视病理机制</div>
            <img
              style={{ width: '100%' }}
              src='./images/arta/cell(222).png'
              alt=''
            />
            <div className="fz_12 fw_500 lh_16 c_85899E ta_c">
              传统观念认为弱视主要影响人类早期视觉皮层；<br />
              集视团队最新的研究揭示成人弱视外膝体-V1小细胞通路和皮层-上丘通路的功能异常；<br />
              针对弱视神经损伤位点的训练有望解决传统疗法年龄限制、依从性差、效果不佳、回退率高等问题。
            </div>
          </div>
          <div className="Arta_principles">
            {/* <div className="Arta_principles-title linear-gradient">全新的技术原理</div> */}
            <div className="Arta_principles-title linear-gradient">自主研发的技术原理</div>
            <div className="Arta_principles-desc linear-gradient-grey">
              {/* <span>独创的双眼推拉训练方案，</span> */}
              <span>双眼推拉训练方案，</span>
              <span>提升双眼信息感知能力</span>
            </div>
            {/* PC端图片 */}
            <div className="Arta_principles-imgPc flex_row flex_jc-c">
              <img
                src='./images/arta/sytl.png'
                alt=''
              />
            </div>
            {/* 移动端图片 */}
            <div className="Arta_principles-imgMobile flex_row flex_jc-c">
              <img
                style={{ width: '90%' }}
                src='./images/arta/sytl-390.png'
                alt=''
              />
            </div>
          </div>
          <div className="Arta_chart">
            <div className="Arta_chart-title ta_c linear-gradient">
              <span>埃尔塔®</span>
              {/* <span>全年龄段疗效优于现有方案</span> */}
              <span>多年龄段临床试验中呈现良好干预效果</span>
            </div>
            <div className="Arta_chartBlock">
              <div className="Arta_chart-left">
                {/* <div className="Arta_chart-leftTitle">
                  <span>临床</span>
                  <span>有效率对比</span>
                </div> */}
                <div className="Arta_chart-leftLeg">
                  <div className="Arta_chart-leftItem">
                    <div className="Arta_chart-itemIcon"></div>
                    <div className="c_85899E">单眼遮盖</div>
                  </div>
                  <div className="Arta_chart-leftItem">
                    <div className="Arta_chart-itemIcon"></div>
                    <div className="c_85899E">某FDA获批疗法A</div>
                  </div>
                  <div className="Arta_chart-leftItem">
                    <div className="Arta_chart-itemIcon"></div>
                    <div className="c_85899E">某FDA获批疗法B</div>
                  </div>
                  <div className="Arta_chart-leftItem">
                    <div className="Arta_chart-itemIcon"></div>
                    <div className="c_23253B">埃尔塔</div>
                  </div>
                </div>
              </div>
              <div className="Arta_chart-right flex_col flex_jc-c flex_ai-c">
                <img
                  style={{ width: '100%' }}
                  src='./images/arta/lcdb.png'
                  alt=''
                />
              </div>
            </div>
            <div className="Arta_chart-desc">经既有多中心临床试验数据验证，临床疗效表现优异，有效弥补传统诊疗方式的应用短板，为弱视临床诊疗提供全新干预方案。</div>
          </div>
        </div>
      </div>
      <div className="Arta_AR">
        <div className="Arta_AR-right">
          <div className="Arta_AR-rightContent">
            <div className="Arta_principles-title linear-gradient">全场景融合AR技术</div>
            {/* <div className="Arta_principles-desc c_85899E">弱视治疗新方式</div> */}
            <div className="Arta_principles-desc c_85899E">弱视训练新方式</div>
            <div className="Arta_AR-rightBlock1">
              <img
                className='Arta_AR-BlockIcon'
                src='./images/arta/ARglasses_icon.png'
                alt=''
              />
              {/* <div className="Arta_AR-BlockText">首创AR技术，<br />不额外占用训练时间，</div> */}
              <div className="Arta_AR-BlockText">AR技术，<br />不额外占用训练时间，</div>
            </div>
            <div style={{ display: 'flex', flexFlow: 'row' }}>
              <div className="Arta_AR-rightBlock2">
                <img
                  className='Arta_AR-BlockIcon'
                  src='./images/arta/Filter_icon.png'
                  alt=''
                />
                <div className="Arta_AR-BlockText mr_10" style={{ maxWidth: '161px' }}>患者自主选择训练画面，依从性高</div>
              </div>
              <div className="Arta_AR-rightBlock3">
                <img
                  className='Arta_AR-BlockIcon'
                  src='./images/arta/Equipment_icon.png'
                  alt=''
                />
                <div className="Arta_AR-BlockText mr_10" style={{ maxWidth: '260px' }}>支持手机、平板等多种设备作为信息源，更具便利性</div>
              </div>
            </div>
          </div>
        </div>
        <div className="Arta_AR-left">
          <img
            style={{ width: '100%' }}
            src='./images/arta/arta-img-2.jpg'
            alt=''
          />
        </div>
      </div>
      {/* PC端 */}
      <div className="Arta_enterprisePc">
        <div className="Arta_enterprise-left flex_center">
          <img
            src='./images/arta/artawork-img.png'
            alt=''
          />
        </div>
        <div className="flex_row flex_jc-sb">
          <div className=""></div>
          <div className="Arta_enterprise-right" style={{ height: 'auto' }}>
            <div className="Arta_AR-rightContent">
              <div className="fz_48 fw_700 lh_56 mt_173 linear-gradient">埃尔塔ARTA®<br />企业版一体机</div>
              <div className="fz_24 fw_500 lh_28 c_85899E mt_58">内置弱视训练、检查、管理三大模块，<br />覆盖弱视患者训练治疗全周期。</div>
              <div className="flex_col gap_65 mt_127">
                <div className="flex_row gap_24 flex_ai-c">
                  <img
                    className="Arta_enterprise-itemIcon"
                    src='./images/arta/artawork1_icon.png'
                    alt=''
                  />
                  <div>
                    <div className="fz_24 fw_700 lh_28 c_23253B">视功能评估</div>
                    <div className="Arta_enterprise-itemDesc">在ARTA视力检查系统完成相关CSF与BP检查，录入患者参数</div>
                  </div>
                </div>
                <div className="flex_row gap_24 flex_ai-c">
                  <img
                    className="Arta_enterprise-itemIcon"
                    src='./images/arta/artawork2_icon.png'
                    alt=''
                  />
                  <div>
                    <div className="fz_24 fw_700 lh_28 c_23253B">定制化训练强度</div>
                    <div className="Arta_enterprise-itemDesc">系统会检查参数并同步对应患者训练强度，患者进入训练界面后自动调整强度，无需额外操作</div>
                  </div>
                </div>
                <div className="flex_row gap_24 flex_ai-c">
                  <img
                    className="Arta_enterprise-itemIcon"
                    src='./images/arta/artawork3_icon.png'
                    alt=''
                  />
                  <div>
                    <div className="fz_24 fw_700 lh_28 c_23253B">动态监测</div>
                    <div className="Arta_enterprise-itemDesc">实时记录患者训练成长曲线，根据训练数据进一步指导并定制后续训练方案</div>
                  </div>
                </div>
              </div>
              <div
                className='Arta_enterprise-btn mb_20'
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
              >
                <Link
                  to='/aboutUs'
                  onClick={() => {
                    document.scrollingElement.scrollTop = 0
                  }}
                >
                  立即咨询
                  <img
                    className='Wearable_product-rightArrow'
                    src={hovered ? './images/home/arrow-right-whiteLine.png' : './images/home/arrow-right-blackLine.png'}
                    alt=''
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* 移动端 */}
      <div className="Arta_enterpriseMobile">
        <div className="Arta_principles-title linear-gradient">埃尔塔ARTA®企业版一体机</div>
        <div className="Arta_principles-desc c_85899E">内置弱视训练、检查、管理三大模块，<br />覆盖弱视患者训练治疗全周期。</div>
        <img
          className='mt_20'
          style={{ width: '100%' }}
          src='./images/arta/artawork-img-390.png'
          alt=''
        />
        <div className='pageMargin'>
          <div className="flex_col gap_40 mt_32">
            <div className="flex_col flex_ai-c">
              <img
                className="Arta_enterprise-itemIcon"
                src='./images/arta/artawork1_icon.png'
                alt=''
              />
              <div className="fz_18 fw_700 lh_21 c_23253B mt_10">视功能评估</div>
              <div className="fz_12 fw_500 lh_16 c_85899E mt_6 mr_45 ml_45 ta_c">在ARTA视力检查系统完成相关CSF与BP检查，录入患者参数</div>
            </div>
            <div className="flex_col flex_ai-c">
              <img
                className="Arta_enterprise-itemIcon"
                src='./images/arta/artawork2_icon.png'
                alt=''
              />
              <div className="fz_18 fw_700 lh_21 c_23253B mt_10">定制化训练强度</div>
              <div className="fz_12 fw_500 lh_16 c_85899E mt_6 mr_45 ml_45 ta_c">系统会检查参数并同步对应患者训练强度，患者进入训练界面后自动调整强度，无需额外操作</div>
            </div>
            <div className="flex_col flex_ai-c">
              <img
                className="Arta_enterprise-itemIcon"
                src='./images/arta/artawork3_icon.png'
                alt=''
              />
              <div className="fz_18 fw_700 lh_21 c_23253B mt_10">动态监测</div>
              <div className="fz_12 fw_500 lh_16 c_85899E mt_6 mr_45 ml_45 ta_c">实时记录患者训练成长曲线，根据训练数据进一步指导并定制后续训练方案</div>
            </div>
          </div>
          <div className='flex_row flex_jc-c'>
            <div
              className='Arta_enterprise-btn'
              onMouseEnter={() => setHovered(true)}
              onMouseLeave={() => setHovered(false)}
            >
              <Link
                to='/aboutUs'
                onClick={() => {
                  document.scrollingElement.scrollTop = 0
                }}
              >
                立即咨询
                <img
                  className='Wearable_product-rightArrowMobile'
                  src={hovered ? './images/home/arrow-right-whiteLine.png' : './images/home/arrow-right-blackLine.png'}
                  alt=''
                />
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="Arta_tip">科普宣传内容仅供参考，不构成任何医疗建议。系列产品需在医生指导下购买和使用。</div>
      <Footer />
    </div>
  );
}

export default Arta;